// Web-Audio synthesised alert sounds (no binary assets) + custom uploaded sound playback.
const BACKEND = process.env.REACT_APP_BACKEND_URL || "";

export const SOUND_OPTIONS = [
  { key: "chime", label: "Chime" },
  { key: "bell", label: "Bell" },
  { key: "classic", label: "Classic Beep" },
  { key: "alarm", label: "Alarm" },
  { key: "dingdong", label: "Ding Dong" },
];

// each: [frequency, duration(s), type]
const SEQS = {
  chime: [[523.25, 0.16, "sine"], [659.25, 0.16, "sine"], [783.99, 0.28, "sine"]],
  bell: [[880, 0.5, "triangle"], [880, 0.5, "triangle"]],
  classic: [[1000, 0.14, "square"], [0, 0.06, "square"], [1000, 0.14, "square"]],
  alarm: [[800, 0.14, "sawtooth"], [1050, 0.14, "sawtooth"], [800, 0.14, "sawtooth"], [1050, 0.14, "sawtooth"], [800, 0.14, "sawtooth"]],
  dingdong: [[659.25, 0.3, "sine"], [523.25, 0.45, "sine"]],
};

let audioCtx;
function ctx() {
  const AC = window.AudioContext || window.webkitAudioContext;
  if (!AC) return null;
  audioCtx = audioCtx || new AC();
  return audioCtx;
}

function beep(c, freq, start, dur, type) {
  if (!freq) return;
  const osc = c.createOscillator();
  const gain = c.createGain();
  osc.type = type || "sine";
  osc.frequency.value = freq;
  gain.gain.setValueAtTime(0.0001, start);
  gain.gain.exponentialRampToValueAtTime(0.35, start + 0.02);
  gain.gain.exponentialRampToValueAtTime(0.0001, start + dur);
  osc.connect(gain).connect(c.destination);
  osc.start(start);
  osc.stop(start + dur + 0.02);
}

export function playSound(key, customUrl) {
  try {
    if (key === "custom") {
      if (!customUrl) return;
      const src = customUrl.startsWith("http") ? customUrl : `${BACKEND}${customUrl}`;
      const a = new Audio(src);
      a.volume = 1;
      a.play().catch(() => {});
      return;
    }
    const c = ctx();
    if (!c) return;
    if (c.state === "suspended") c.resume();
    const seq = SEQS[key] || SEQS.chime;
    let t = c.currentTime + 0.02;
    seq.forEach(([freq, dur, type]) => { beep(c, freq, t, dur, type); t += dur; });
  } catch (e) { /* ignore */ }
}

// Best-effort resume of the audio context after a user gesture (autoplay policy).
export function primeAudio() {
  try { const c = ctx(); if (c && c.state === "suspended") c.resume(); } catch (e) {}
}
